
import { IStatus } from '@interfaces/chat/chatI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const chatContactStatusSlice = createSlice({
    name: 'chatContactStatus',
    initialState: {
        status: [],
    } as {status: IStatus[]},
    reducers:{
        setChatContactStatus: (state, action: PayloadAction<IStatus>) => {
            const index = state.status.findIndex(c => action.payload.id === c.id);
            if(index === -1)
                state.status.push(action.payload);
            else
            {
                state.status[index] = {
                    ...state.status[index],
                    ...action.payload
                }
            }
        },
        removeChatContactStatus: (state, action: PayloadAction<IStatus>) => {
            const filteredData = state.status.filter(status => status.id !== action.payload.id);
            state.status = filteredData;
        },
        cleanChatContactStatus: (state) => {
            state.status = []; 
        }
    }
});

export const {setChatContactStatus, removeChatContactStatus, cleanChatContactStatus} = chatContactStatusSlice.actions;
export default chatContactStatusSlice.reducer;